import { GettersType } from "@/store/getters/type";
import { IStoreType } from "@/interfaces/IStoreType";
import { IChip } from "@/interfaces/IChip";

export default {
  [GettersType.CHIP_ACTIVE]: (state: IStoreType): IChip | undefined =>
    state.chips.find((c) => c.active),
  [GettersType.GET_CHIPS]: (state: IStoreType): IChip[] => state.chips,
};
